/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ApplicationEmployeeUsageHeatmapQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['UUID']['input'];
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ApplicationEmployeeUsageHeatmapQuery = { __typename: 'Query', clientApplication?: { __typename: 'ClientApplicationType', id: string, employees?: { __typename: 'ClientEmployeeTypeConnection', edges: Array<{ __typename: 'ClientEmployeeTypeEdge', node?: { __typename: 'ClientEmployeeType', id: string, sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', edges: Array<{ __typename: 'ClientEmployeeSessionTypeEdge', node?: { __typename: 'ClientEmployeeSessionType', id: string, createdAt: string } | null } | null> } | null } | null } | null> } | null } | null };



export const ApplicationEmployeeUsageHeatmapDocument = `
    query ApplicationEmployeeUsageHeatmap($applicationId: UUID!, $clientId: UUID!) {
  clientApplication(id: $applicationId, clientId: $clientId) {
    id
    employees {
      edges {
        node {
          id
          sessions {
            edges {
              node {
                id
                createdAt
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useApplicationEmployeeUsageHeatmapQuery = <
      TData = ApplicationEmployeeUsageHeatmapQuery,
      TError = unknown
    >(
      variables: ApplicationEmployeeUsageHeatmapQueryVariables,
      options?: Omit<UseQueryOptions<ApplicationEmployeeUsageHeatmapQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApplicationEmployeeUsageHeatmapQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApplicationEmployeeUsageHeatmapQuery, TError, TData>(
      {
    queryKey: ['ApplicationEmployeeUsageHeatmap', variables],
    queryFn: fetcher<ApplicationEmployeeUsageHeatmapQuery, ApplicationEmployeeUsageHeatmapQueryVariables>(ApplicationEmployeeUsageHeatmapDocument, variables),
    ...options
  }
    )};

useApplicationEmployeeUsageHeatmapQuery.getKey = (variables: ApplicationEmployeeUsageHeatmapQueryVariables) => ['ApplicationEmployeeUsageHeatmap', variables];

export const useInfiniteApplicationEmployeeUsageHeatmapQuery = <
      TData = InfiniteData<ApplicationEmployeeUsageHeatmapQuery>,
      TError = unknown
    >(
      variables: ApplicationEmployeeUsageHeatmapQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApplicationEmployeeUsageHeatmapQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApplicationEmployeeUsageHeatmapQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApplicationEmployeeUsageHeatmapQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ApplicationEmployeeUsageHeatmap.infinite', variables],
      queryFn: (metaData) => fetcher<ApplicationEmployeeUsageHeatmapQuery, ApplicationEmployeeUsageHeatmapQueryVariables>(ApplicationEmployeeUsageHeatmapDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteApplicationEmployeeUsageHeatmapQuery.getKey = (variables: ApplicationEmployeeUsageHeatmapQueryVariables) => ['ApplicationEmployeeUsageHeatmap.infinite', variables];


useApplicationEmployeeUsageHeatmapQuery.fetcher = (variables: ApplicationEmployeeUsageHeatmapQueryVariables) => fetcher<ApplicationEmployeeUsageHeatmapQuery, ApplicationEmployeeUsageHeatmapQueryVariables>(ApplicationEmployeeUsageHeatmapDocument, variables);
